import { XTextarea } from '../../../../components'
import XModal from '../../../../components/common/XModal';

const AddCaseNoteModal = ({ isOpen, setIsOpen, noteFormik }) => {

    return (
      <XModal
        isOpen={isOpen}
        title="Add Note"
        onClose={() => setIsOpen(false)}
        onSubmit={noteFormik.handleSubmit}
      >
        <XTextarea {...noteFormik.getFieldProps("note")} />
      </XModal>
    );
}

export default AddCaseNoteModal
